import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { SessionTokenService } from '../services/session-token.service';

export const REQUIRE_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokens = inject(SessionTokenService);
  const token = tokens.token;
  if (!token) {
    return next(req);
  } else {
    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next(authReq);
  }
};
